import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useDeletePerson = ({ matterId, subsetId }: { matterId: string; subsetId: string }) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ personId }: { personId: string }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/persons/${personId}`,
        fetchConfig,
      );

      if (response.status === 403) {
        toast.error('You are not authorised to delete this entity');
        throw new Error('Forbidden');
      }

      if (!response.ok) {
        throw new Error('Failed to delete entity');
      }
    },
    onSuccess: () => {
      trackCustomEvent(TrackingEventsV2.PersonDelete, { matterId });
      queryClient.invalidateQueries({ queryKey: [QueryEntity.SubsetPersons, { subsetId }] });
      toast.success('Entity deleted');
    },
    onError: () => {
      toast.error('Failed to delete entity');
    },
  });
};
